<template>
  <span style="display: inline-block;">
    <span v-for="word in words" class="word nowrap">
      <span v-for="letter, key in word"  v-if="letter !== ' '" :class="['letter', {'letter_animated': isActive}, {'letter_wider': letter == 'f'}]">
        <span :style="`animation-delay: ${(key * 70)/1000}s`">{{ letter }}</span>
      </span>
    </span>
    <template v-if="isActive">
      <ins class="decor-line decor-line_hor1"></ins>
      <ins class="decor-line decor-line_hor2"></ins>
      <ins class="decor-line decor-line_vert1"></ins>
      <template v-if="titleValue.length > 10">
        <ins class="decor-line decor-line_hor3"></ins>
        <ins class="decor-line decor-line_vert2"></ins>
      </template>
    </template>
  </span>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'pageTitleContent',
    props: ['titleValue', 'isActive'],
    computed: mapGetters({
      pageReady: 'pageReady',
    }),
    data() {
      return {
        words: this.titleValue.split(' '),
      };
    },
    watch: {
      titleValue() {
        if (this.titleValue) {
          this.words = [];
          setTimeout(() => {
            this.words = this.titleValue.split(' ');
          }, 100);
        }
      },
    },
  };
</script>

<style>
  @keyframes titleShow {
    0%   {
      transform: translateX(-100%);
    }
    100% { 
      transform: translateX(0);
    }
  }

  @keyframes lineHor {
    0%   {
      left: -100%;
    }
    100% { 
      left: 100%;
    }
  }

  @keyframes lineVert1 {
    0%   {
      top: 100%;
    }
    100% { 
      top: -100%;
    }
  }

  .section__title {
    line-height: 172px;
  }

  .animated-title {
    position: relative;

    .word {
      display: inline-block;
      margin-right: 25px;

      &:last-of-type,
      &:last-child {
        margin-right: 0;
      }

      .letter {
        vertical-align: bottom;
      }
    }

    .letter {
      overflow: hidden;
      display: inline-block;

      span {
        display: inline-block;
        transform: translateX(-100%);
      }
    }

    .animating &,
    &.animating {
      .letter {
        &.letter_animated {
          span {
            animation: titleShow 1.3s cubic-bezier(0.500, 0.000, 0.100, 1.000) forwards;
          }
        }
      }
    }

    &.section__title.animating:not(.static) {
      .decor-line {
        &_hor2 {
          top: 120px;
        }
      }
    }

    &.animating:not(.static) {
      .decor-line {
        position: absolute;
        overflow: hidden;

        &:before {
          content: '';
          background: $lightest-color;
          position: absolute;

          .light-bg & {
            background: $darkest-color;
          }
        }

        &_hor1,
        &_hor2,
        &_hor3 {
          height: 1px;

          &:before {
            height: 1px;
            top: 0;
            left: -100%;
            width: 100%;
            animation: lineHor 1.5s cubic-bezier(0.500, 0.000, 0.100, 1.000);
          }
        }

        &_hor1 {
          width: 25%;
          top: 2px;
          left: -20px;
        }

        &_hor2 {
          width: 22%;
          top: 114px;
          left: 23%;

          &:before {
            animation-delay: 0.3s;
          }
        }

        &_hor3 {
          width: 19%;
          top: 52px;
          right: 17%;

          &:before {
            animation-delay: 0.5s;
          }
        }

        &_vert1,
        &_vert2 {
          width: 1px;

          &:before {
            width: 1px;
            left: 0;
            height: 100%;
            top: 100%;
          }
        }

        &_vert1 {
          height: 100%;
          top: -10%;
          left: 34%;

          &:before {
            animation: lineVert1 1.3s cubic-bezier(0.500, 0.000, 0.100, 1.000) 0.5s;
          }
        }

        &_vert2 {
          height: 100%;
          top: -10%;
          right: 36%;

          &:before {
            animation: lineVert1 1.3s cubic-bezier(0.500, 0.000, 0.100, 1.000) 0.6s reverse;
          }
        }
      }
    }

    .static,
    &.static {
      .letter {
        span {
          transform: translateX(0) !important;
          animation: none !important;
        }
      }
      .decor-line {
        display: none;
      }
    }
  }

  @media (max-width: 990px) {
    .section__title {
      line-height: 140px;
    }
  }

  @media (max-width: 850px) {
    .animated-title {
      &.founder__name {
        .word {
          margin-right: 6px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .section__title {
      line-height: 57px;

      .page_ru & {
        line-height: 50px;
      }

      .decor-line {
        display: none;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PageTitleContent.vue?516cae80